import { fetchApi } from '@/config/axiosSetting';
import {
  DamagedPartDescriptionFunctionModalProps,
  DamagedPartDescriptionModalProps,
} from '@/common/components/adjusterReport/damagedPoints/damagedPointsDescriptionModal/DamagedPointsDescriptionModal.type';
import { DamagedPartDescriptionQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/damagedPartDescription/damagedPartDescriptionQuery.type';

export const damagedPartDescriptionFunction = ({
  damaged_id,
  data,
  id,
  method,
  userType,
}: DamagedPartDescriptionQueryParamsType &
  DamagedPartDescriptionModalProps &
  DamagedPartDescriptionFunctionModalProps) => {
  const url = () => {
    switch (userType) {
      case 'culprit':
      case 'damaged':
        return `property/reports/${id}/accident_users/${userType}/images/damaged_parts_description/`;

      case 'initial':
        return `initial/reports/${id}/images/damaged_parts_description/`;

      case 'body':
        return `body/reports/${id}/images/damaged_parts_description/`;
    }
  };

  if (method === 'get') {
    return fetchApi.get(url(), {
      params: {
        damaged_id: userType === 'damaged' ? damaged_id : undefined,
      },
    });
  }

  return fetchApi.post(url(), data, {
    params: {
      damaged_id: userType === 'damaged' ? damaged_id : undefined,
    },
  });
};
